const pt = String(localStorage.getItem("pt"));

const DocMenuConfig: object = [
  {
    heading: "mainmenu",
    pages: [
      {
        heading: "dashboard",
        route: "/dashboardpcp",
        svgIcon: "media/icons/duotone/Home/Home.svg",
        fontIcon: "bi-app-indicator"
      }
      // {
      //   heading: "estoretrans",
      //   route: "/estoretrans",
      //   svgIcon: "media/icons/duotone/Interface/Settings-02.svg",
      //   fontIcon: "bi-layers"
      // }
    ]
  },
  {
    heading: "settings",
    route: "/settings",
    pages: [
      {
        heading: "profile",
        route: "/settings/profile/",
        svgIcon: "media/icons/duotone/General/User.svg",
        fontIcon: "bi-archive"
      },
      {
        heading: "Leader's Toolkit",
        route: "/settings/team-materials/",
        svgIcon: "media/icons/duotone/Files/Folder.svg",
        fontIcon: "bi-folder"
      },
      {
        heading: "ai247",
        route: "/settings/ai247-portal/",
        svgIcon: "media/icons/duotone/Communication/Address-card.svg",
        fontIcon: "bi-building"
      },
      {
        heading: "sites",
        route: "/sites",
        svgIcon: "media/icons/duotone/Design/Sketch.svg",
        fontIcon: "bi-globe",
        condition: "sitesPreview"
      },
      {
        heading: "Log-out",
        route: "/logout",
        svgIcon: "media/icons/duotone/Navigation/Sign-out.svg",
        fontIcon: "bi-archive"
      }
    ]
  },
];


export default DocMenuConfig;
